import { render, staticRenderFns } from "./RemoveAccountModal.vue?vue&type=template&id=e84e4d82&scoped=true&"
import script from "./RemoveAccountModal.vue?vue&type=script&lang=js&"
export * from "./RemoveAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAccountModal.vue?vue&type=style&index=0&id=e84e4d82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84e4d82",
  null
  
)

export default component.exports